var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_981_1922)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83895 0.357886C4.71124 0.135913 7.59637 0.135913 10.4687 0.357886C10.8712 0.387897 11.2495 0.561225 11.5351 0.846409C11.8207 1.13159 11.9946 1.50973 12.0252 1.91217C12.074 2.55446 12.1121 3.19065 12.1395 3.82074V3.83217C9.79423 3.71776 7.44407 3.75097 5.10295 3.9316C4.70064 3.96158 4.3224 4.13474 4.03682 4.41969C3.75124 4.70464 3.57724 5.0825 3.54638 5.48474C3.37537 7.70715 3.33721 9.93779 3.43209 12.1647C2.90638 12.1388 2.37533 12.1057 1.83895 12.0653C1.43646 12.0353 1.05807 11.862 0.772466 11.5768C0.486864 11.2916 0.312979 10.9135 0.282377 10.511C0.0601714 7.64905 0.0601714 4.77415 0.282377 1.91217C0.313013 1.50954 0.487061 1.13127 0.772898 0.846057C1.05874 0.560849 1.4374 0.387635 1.84009 0.357886H1.83895Z",
    fill: "#2859C5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7328 3.93015C10.8605 3.70818 7.97535 3.70818 5.10306 3.93015C4.70021 3.96023 4.32153 4.13389 4.03588 4.41954C3.75023 4.70519 3.57657 5.08387 3.54649 5.48672C3.32435 8.34832 3.32435 11.2228 3.54649 14.0844C3.57709 14.4869 3.75098 14.865 4.03658 15.1502C4.32219 15.4354 4.70057 15.6087 5.10306 15.6387C7.97535 15.8607 10.8605 15.8607 13.7328 15.6387C14.1353 15.6087 14.5137 15.4354 14.7993 15.1502C15.0849 14.865 15.2587 14.4869 15.2893 14.0844C15.5115 11.2228 15.5115 8.34832 15.2893 5.48672C15.259 5.08407 15.0852 4.70567 14.7996 4.42025C14.514 4.13483 14.1354 3.9602 13.7328 3.93015Z",
    fill: "#8FBFFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_981_1922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.632fba45ee940dfad9331232d0b0a6a3.svg";
export { ForwardRef as ReactComponent };